import React, { useState } from "react";
import { object, SchemaOf, string, array, number } from "yup";
import { Button, FormField, useDidMount } from "@epcnetwork/core-ui-kit";
import { useFormikContext } from "formik";

export const iterableSchema: SchemaOf<IterableType> = object({
  api_key: string().required("This field is required"),
  list_ids: array().of(
    number().min(1, "This field is required").required("This field is required"),
  ),
});

export type IterableType = {
  api_key: string;
  list_ids: number[];
};

const Iterable: React.FC = () => {
  const { setFieldValue } = useFormikContext();

  const [fieldsCount, setFieldsCount] = useState(0);

  const handleAddField = () => {
    setFieldsCount((prev) => prev + 1);
  };

  useDidMount(() => {
    setFieldValue("connector.list_ids", []);
  });

  return (
    <>
      <FormField type="text" name={`connector.api_key`} label="Api Key" placeholder="Api Key" />
      <FormField
        type="number"
        name={`connector.list_ids[0]`}
        label="List Ids (1)"
        placeholder="List Ids"
      />
      {Array.from(Array(fieldsCount), (_, i) => i + 1).map((index) => (
        <FormField
          key={index}
          type="number"
          name={`connector.list_ids[${index}]`}
          label={`List Ids(${index + 1})`}
          placeholder="List Ids"
        />
      ))}
      <Button type="button" appearance="primary-pale" onClick={handleAddField}>
        + Add list id
      </Button>
    </>
  );
};

export default Iterable;
